import {
    CHANGE_LIMIT_CAMPAIGN_RELEVANT_PHRASES_EDITOR,
    CLOSE_CAMPAIGN_RELEVANT_PHRASES_EDITOR,
    INIT_CAMPAIGNS_RELEVANT_PHRASES_EDITORS,
    InitCampaignsRelevantPhrasesEditorsItemData,
    OPEN_CAMPAIGN_RELEVANT_PHRASES_EDITOR,
    RelevantPhrasesEditorAction,
    RESET_CAMPAIGN_RELEVANT_PHRASES_EDITOR,
    SELECT_GOAL_CAMPAIGN_RELEVANT_PHRASES_EDITOR,
    SHOW_RELEVANT_RHRASES_EDITOR_ERRORS,
    TOGGLE_CAMPAIGN_RELEVANT_PHRASES
} from '../actions/relevantPhrases';
import { AdditionalGoalIds } from '../typings/goals';
import {
    CampaignsRelevantPhrasesEditorState,
    RelevantPhrasesState
} from '../typings/relevantPhrases';
import { State } from '../typings/state';

export const defaultRelevantPhrasesState: RelevantPhrasesState = {
    isEnabled: false,
    isVisible: false,
    limit: '',
    goalId: AdditionalGoalIds.notSet,
    errors: {
        limit: [],
        goal: []
    }
};

export function relevantPhrasesEditor(
    state: CampaignsRelevantPhrasesEditorState = {},
    action: RelevantPhrasesEditorAction,
    fullState: State
): CampaignsRelevantPhrasesEditorState {
    switch (action.type) {
        case INIT_CAMPAIGNS_RELEVANT_PHRASES_EDITORS: {
            const editorsData = action.editors.reduce(
                (
                    res: RelevantPhrasesState,
                    {
                        editorId,
                        value
                    }: InitCampaignsRelevantPhrasesEditorsItemData
                ) => {
                    res[editorId] = {
                        ...defaultRelevantPhrasesState,
                        ...value
                    };

                    return res;
                },
                {}
            );

            return {
                ...state,
                ...editorsData
            };
        }

        case OPEN_CAMPAIGN_RELEVANT_PHRASES_EDITOR: {
            const currentState =
                state[action.editorId] || defaultRelevantPhrasesState;

            return {
                ...state,
                [action.editorId]: {
                    ...currentState,
                    isVisible: true
                }
            };
        }

        case CLOSE_CAMPAIGN_RELEVANT_PHRASES_EDITOR: {
            const currentState =
                state[action.editorId] || defaultRelevantPhrasesState;

            return {
                ...state,
                [action.editorId]: {
                    ...currentState,
                    isVisible: false
                }
            };
        }

        case RESET_CAMPAIGN_RELEVANT_PHRASES_EDITOR: {
            const currentState =
                state[action.editorId] || defaultRelevantPhrasesState;

            return {
                ...state,
                [action.editorId]: {
                    ...currentState,
                    ...action.value
                }
            };
        }

        case TOGGLE_CAMPAIGN_RELEVANT_PHRASES: {
            const currentState =
                state[action.editorId] || defaultRelevantPhrasesState;

            return {
                ...state,
                [action.editorId]: {
                    ...currentState,
                    isEnabled: !currentState.isEnabled
                }
            };
        }

        case CHANGE_LIMIT_CAMPAIGN_RELEVANT_PHRASES_EDITOR: {
            const currentState =
                state[action.editorId] || defaultRelevantPhrasesState;

            return {
                ...state,
                [action.editorId]: {
                    ...currentState,
                    limit: action.limit,
                    errors: {
                        ...currentState.errors,
                        limit: []
                    }
                }
            };
        }

        case SELECT_GOAL_CAMPAIGN_RELEVANT_PHRASES_EDITOR: {
            const currentState =
                state[action.editorId] || defaultRelevantPhrasesState;

            return {
                ...state,
                [action.editorId]: {
                    ...currentState,
                    goalId: action.goalId,
                    errors: {
                        ...currentState.errors,
                        goal: []
                    }
                }
            };
        }

        case SHOW_RELEVANT_RHRASES_EDITOR_ERRORS: {
            const { editorId, errors } = action;
            const currentState = state[editorId] || defaultRelevantPhrasesState;

            return {
                ...state,
                [editorId]: {
                    ...currentState,
                    errors
                }
            };
        }

        default:
            return state;
    }
}
